export default "__VITE_ASSET__DfOPIkhe__"